// Define an action for toggling the theme
export const setLoading = () => ({
    type: 'SET_LOADING',
  });
  
  export const unsetLoading = () => ({
    type: 'UNSET_LOADING',
  });  